/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ScheduleTable_ScheduleFragmentDoc } from '../../../../../../components/schedules/ScheduleTable/__generated__/ScheduleTable.graphql';
import { CustomerSubscriptionData_CustomerFragmentDoc } from '../../../../../../components/customers/__generated__/CustomersGridItem.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerSchedulesPageQueryVariables = Types.Exact<{
  customerHandle: Types.Scalars['String'];
}>;


export type CustomerSchedulesPageQuery = { __typename: 'Query', customer?: { __typename: 'Customer', id: string, displayCount: number, waveSubscriptionUsage?: number | null, schedules: Array<{ __typename: 'Schedule', id: string, title: string, description: string, createdAt: any, isScheduleUsedByAnyConfiguration: boolean, syncedDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }>, allDisplays: Array<{ __typename: 'Display', id: string }> }>, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null } | null };


export const CustomerSchedulesPageDocument = gql`
    query CustomerSchedulesPage($customerHandle: String!) {
  customer: customerByHandle(handle: $customerHandle) {
    id
    schedules {
      ...ScheduleTable_schedule
    }
    ...CustomerSubscriptionData_customer
  }
}
    ${ScheduleTable_ScheduleFragmentDoc}
${CustomerSubscriptionData_CustomerFragmentDoc}`;

/**
 * __useCustomerSchedulesPageQuery__
 *
 * To run a query within a React component, call `useCustomerSchedulesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSchedulesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSchedulesPageQuery({
 *   variables: {
 *      customerHandle: // value for 'customerHandle'
 *   },
 * });
 */
export function useCustomerSchedulesPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomerSchedulesPageQuery, CustomerSchedulesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerSchedulesPageQuery, CustomerSchedulesPageQueryVariables>(CustomerSchedulesPageDocument, options);
      }
export function useCustomerSchedulesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerSchedulesPageQuery, CustomerSchedulesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerSchedulesPageQuery, CustomerSchedulesPageQueryVariables>(CustomerSchedulesPageDocument, options);
        }
export type CustomerSchedulesPageQueryHookResult = ReturnType<typeof useCustomerSchedulesPageQuery>;
export type CustomerSchedulesPageLazyQueryHookResult = ReturnType<typeof useCustomerSchedulesPageLazyQuery>;
export type CustomerSchedulesPageQueryResult = ApolloReactCommon.QueryResult<CustomerSchedulesPageQuery, CustomerSchedulesPageQueryVariables>;